module.exports = __webpack_public_path__ + "static/failure-and-beyond@2x-a7b76de7ba2e91f15efb0837d09d36ee.jpg";